import { Field, Float, Int, ObjectType } from '@nestjs/graphql'
import { InvoiceDto } from './invoice.dto'

@ObjectType()
export class PaymentDto {
  @Field({ nullable: true })
  plan?: string

  @Field({ nullable: true })
  stripeCustomerId?: string

  @Field({ nullable: true })
  stripeSubscriptionId?: string

  @Field(t => Float, { nullable: true })
  price?: number

  @Field({ nullable: true })
  cycle?: string

  @Field(t => Date, { nullable: true })
  cancelAt?: Date

  @Field(t => Date, { nullable: true })
  nextBillDue?: Date

  @Field({ nullable: true })
  cardLast4?: string

  @Field({ nullable: true })
  cardExpiry?: string

  @Field({ nullable: true })
  cardType?: string

  @Field({ nullable: true })
  taxCountry?: string

  @Field({ nullable: true })
  taxCountryCode?: string

  @Field({ nullable: true })
  postalCode?: string

  @Field({ nullable: true })
  taxCode?: string

  @Field(t => Int, { nullable: true })
  discountPcApplied?: number

  @Field(t => Int, { nullable: true })
  discountAmountApplied?: number

  @Field(t => [InvoiceDto], { nullable: true })
  invoices?: InvoiceDto[]

  @Field({ nullable: true })
  lastFailedPaymentId?: string
}
